import React, { Component } from 'react';
import AdvisorListingTableItem from './AdvisorListingTableItem';
import { CircularProgress } from '@material-ui/core';

class AdvisorListingsTable extends Component {
  render() {
    let { loadingAdvisorListings } = this.props;
    return (
      <div className="table-responsive shadow">
        <table className="table">
          <thead className="bg-admin-primary text-white h7">
            <tr>
              <th>Count</th>
              <th>Advisor ID</th>
              <th>Advisor First Name</th>
              <th>Advisor Last Name</th>
              <th>Official Email</th>
              <th>Phone Number</th>
              <th>Advisor Type</th>
              <th>Plan</th>
              <th>Date Registered</th>
              <th>Status</th>
              <th>Lister First Name</th>
              <th>Lister Last Name</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {loadingAdvisorListings ? (
              <tr>
                <td>
                  <CircularProgress color="primary" size={'1rem'} />
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            ) : (
              this.props.listings.map((listing, index) => (
                <AdvisorListingTableItem
                  key={listing.id}
                  listing={listing}
                  number={this.props.listings.length - index}
                />
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default AdvisorListingsTable;
